import { gql } from '@apollo/client'

export default gql(`
    mutation autoAssociateVirtualImages($project: String! $assetId: ID! $module: String!) {
        autoAssociateVirtualImages(
            input: {
                project: $project,
                id: $assetId
            }
            module : $module
        ) {
            id
            status
        }
    }`
)
